<template>
  <div>
    <b-overlay
      variant="white"
      :show="showLoading"
      spinner-variant="primary"
      blur="0"
      opacity=".75"
      rounded="sm"
    >
      <form-wizard
        color="#7367F0"
        :title="null"
        :subtitle="null"
        shape="square"
        finish-button-text="Next"
        back-button-text="Previous"
        class="mb-3"
        @on-complete="formSubmitted"
      >
        <!-- validation tab -->
        <tab-content title="รายละเอียดผู้ร้องทุกข์" :before-change="tab1check">
          <validation-observer ref="accountRules" tag="form">
            <Step1
              :personals="personals"
              :attorneys="attorneys"
              :selectedChannel="selectedChannel"
              :showChannel="parentComponent === 'screening' ? true : false"
              :isAttorneyCompliant="isAttorneyCompliant"
              :ComponentName="ComponentName"
              @personal-modal-clicked="personalModalClicked"
              @personal-deleted="personalDeleted"
              @handle-selectedChannel="updateSelectedChannel"
              @handle-selectedProvince="updateSelectedProvince"
              @handle-isAttorneyComplaintChange="onIsAttorneyComplaintChange"
              @handle-selectDateComplaint="updateSelectedDateComplaint"
            />
          </validation-observer>
        </tab-content>

        <!-- validation tab -->
        <tab-content
          title="ผู้ประกอบธุรกิจ (ผู้ถูกร้องทุกข์)"
          :before-change="tab2check"
        >
          <validation-observer ref="accountRules" tag="form">
            <Step2
              :company="company"
              :complainantCompany="complainantCompany"
              :IsEdit_CompanySearch="true"
              :ComponentName="ComponentName"
              @entrepreneur-btn-add-clicked="entrepreneurBtnAddClicked"
              @company-digital-modal-clicked="companyModalClicked"
              @company-name-change="setCompanyName"
              @onBtnCompanySearchClicked="onBtnCompanySearchClicked"
              @onBtnCompanySearchDeleteClicked="onBtnCompanySearchDeleteClicked"
            />
          </validation-observer>
        </tab-content>

        <!-- validation tab -->
        <tab-content
          title="รายละเอียดเรื่องร้องทุกข์"
          :before-change="tab3check"
        >
          <validation-observer ref="accountRules" tag="form">
            <Step3
              ref="Step3Ref"
              :complaintDetail="complaintDetail"
              :complaintDetailMultiSelect="complaintDetailMultiSelect"
              :complaintCatagoryDetail="complaintCatagoryDetail"
              :mouCompanies="mouCompanies"
              :selectedCompanyMOU="selectedCompanyMOU"
              :needFastTrack="needFastTrack"
              @checkboxChanged="checkboxChanged"
              @selectedCompanyMOUChanged="onUpdateSelectedCompanyMou"
              @onNeedFastTrackChanged="onNeedFastTrackChange"
            />
          </validation-observer>
        </tab-content>

        <!-- <validation-observer>
        <Step3
          ref="tmpStep3Ref"
          :complaintDetail="complaintDetail"
          :complaintDetailMultiSelect="complaintDetailMultiSelect"
          :complaintCatagoryDetail="complaintCatagoryDetail"
          @checkboxChanged="checkboxChanged"
        />
      </validation-observer> -->

        <!-- validation tab -->
        <tab-content title="ตรวจสอบข้อมูล">
          <validation-observer ref="accountRules" tag="form">
            <Step4
              :personals="personals"
              :attorneys="attorneys"
              :complainantCompany="complainantCompany"
              :company="company"
              :complaintDetail="complaintDetail"
              :complaintDetailMultiSelect="complaintDetailMultiSelect"
              :complaintCatagoryDetail="complaintCatagoryDetail"
              :mouCompanies="mouCompanies"
              :selectedCompanyMOU="selectedCompanyMou"
              :needFastTrack="needFastTrack"
              :isAttorneyCompliant="isAttorneyCompliant"
            />

            <!-- <Step5
           @handle-upload="onAttachFileUploaded"
             @handle-delete="onAttachFileDelete"
            :attach-files="attachFiles"
          /> -->
          </validation-observer>
        </tab-content>
      </form-wizard>
    </b-overlay>

    <ModalPersonal
      ref="modalPersonalComponent"
      :personal="modalPersonalObj"
      :suggestions="suggestions"
      @ModalLocalSave="personalModalLocalSave"
    />

    <ModalPersonal
      ref="modalAttorneyComponent"
      :personal="modalPersonalObj"
      :suggestions="suggestions"
      @ModalLocalSave="attorneyModalLocalSave"
    />

    <ModalDigitalId
      ref="modalDigitalIdComponent"
      :userId="currentUserIdModal"
      @handle-success="onModalDigitalIdSuccess"
    />

    <ModalCompany
      ref="modalCompanyComponent"
      :company="currentCompanyModal"
      @handle-submit="onBtnCompanySearchSubmit"
    />

    <ModalDigitalIdCompany
      ref="modalDigitalIdCompanyComponent"
      :compId="currentCompIdModal"
      @handle-success="onModalDigitalIdCompanySuccess"
    />
  </div>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BModal,
  BForm,
  BButton,
  BOverlay,
} from "bootstrap-vue";
import { required, email } from "@validations";
import Step1 from "./steps/Step1.vue";
import Step2 from "./steps/Step2.vue";
import Step3 from "./steps/Step3.vue";
import Step4 from "./steps/Step4.vue";
import Step5 from "./steps/Step5.vue";

import ModalPersonal from "./steps/ModalPersonal.vue";
import ModalDigitalId from "../components/DigitalIdUserModal.vue";
import ModalCompany from "../components/ModalCompany.vue";
import ModalDigitalIdCompany from "../components/DigitalIdCompanyModal.vue";

import * as userStore from "@/store/api/user/index.js";
import * as companyStore from "@/store/api/company/index.js";
import * as userData from "@/auth/localStorageUtils.js";
import appsettings from "@/store/app-settings/index.js";

import {
  complaintSubjectSelects,
  complaintTypeSelects,
  complaintReasonSelects,
  complaintPlaceSelects,
  complaintMotivateSelects,
  complaintPaymentMethodSelects,
  complaintOnlineRadio,
  attachFiles,
} from "../../../@fake-db/data/masters/complaint-selects.js";

import * as ComplaintAPI from "@/store/api/complaint/complaint.js";
import * as CompanyApi from "@/store/api/company/index.js";
import { forEach } from "postcss-rtl/lib/affected-props";

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    FormWizard,
    TabContent,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BOverlay,
    vSelect,
    BFormInvalidFeedback,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    BForm,
    BButton,
    BModal,
    Step1,
    Step2,
    Step3,
    Step4,
    Step5,
    ModalPersonal,
    ModalDigitalId,
    userStore,
    ComplaintAPI,
    userData,
    ModalCompany,
    ModalDigitalIdCompany,
  },
  props: {
    ComponentName: "",
  },
  data() {
    return {
      showLoading: false,
      currentCompanyModal: {},
      complainantCompany: [],
      suggestions: [
        {
          data: [],
        },
      ],
      userId: "",
      attachFiles: [],
      personals: [],
      attorneys: [],
      complaintDetail: [],
      complaintDetailMultiSelect: [],
      mouCompanies: [],
      complaintCatagoryDetail: [
        {
          catagoryDeId: 0,
          complaintId: "00000000-0000-0000-0000-000000000000",
          description: null,
          masterTypeId: 8,
        },
        {
          catagoryDeId: 0,
          complaintId: "00000000-0000-0000-0000-000000000000",
          description: null,
          masterTypeId: 9,
        },
        {
          catagoryDeId: 0,
          complaintId: "00000000-0000-0000-0000-000000000000",
          description: null,
          masterTypeId: 10,
        },
        {
          catagoryDeId: 0,
          complaintId: "00000000-0000-0000-0000-000000000000",
          description: null,
          masterTypeId: 12,
        },
      ],
      masterIdList: [],
      company: {
        id: 1001,
        name: "",
        detail: "",
        complaintDetail: "",
      },
      complaintSubjectSelects,
      complaintTypeSelects,
      complaintReasonSelects,
      complaintPlaceSelects,
      complaintMotivateSelects,
      complaintPaymentMethodSelects,
      complaintOnlineRadio,
      modalCurrentId: 1,
      modalPersonalObj: {
        id: 1,
        identity: "",
        title: "",
        name: "",
        lastname: "",
        sex: "",
        dateofbirth: "",
        address: "",
        tumbol: "",
        ampher: "",
        province: "",
        zipcode: "",
        tel: "",
        mobile: "",
        email: "",
        line: "",
      },
      currentUserIdModal: "",
      modalMode: "personal",
      currentCompIdModal: "",
      parentComponent: "",
      selectedChannel: 70,
      isAttorneyCompliant: false,
      provinceCode: "",
      deptComplaintCode: "",
      dateComplaint: null,
      selectedCompanyMou: {},
      needFastTrack: false,
    };
  },
  beforeMount() {
    var self = this;

    this.userId = userData.userId();
    console.log("personals", this.personals, this.attorneys);

    console.log("222: ", this.suggestions);
    ComplaintAPI.GetAllSubDistrictAutocomplete()
      .then(function(response) {
        // handle success
        console.log("then", response);
        //this.suggestions = response.data;

        //console.log("111: ",response.data.data)
        self.suggestions[0].data = response.data.data;

        //console.log("111: ",self.suggestions)
        //console.log("222: ",self.suggestions2)
      })
      .catch(function(error) {
        // handle error
        console.log("error", error);
      })
      .then(function() {
        // always executed
        //console.log('GET')
      });

    //5,6,7 is mastertypeId
    ComplaintAPI.GetInitComplaintTmMasterType([5, 6, 7])
      .then(function(response) {
        self.complaintDetail = response.data.data;

        //console.log("self.complaintDetail: ",self.complaintDetail)
      })
      .catch(function(error) {
        // handle error
        console.log("error", error);
      })
      .then(function() {
        // always executed
        //console.log('GET')
      });

    ComplaintAPI.GetInitComplaintTmMasterType([8, 10, 12])
      .then(function(response) {
        self.complaintDetailMultiSelect = response.data.data;
      })
      .catch(function(error) {
        // handle error
        console.log("error", error);
      })
      .then(function() {
        // always executed
        //console.log('GET')
      });

    this.parentComponent = this.$route.query.parentComponent;
  },
  methods: {
    onBtnCompanySearchClicked(companyObj) {
      this.currentCompanyModal = companyObj;
      this.$refs.modalCompanyComponent.$refs["modal-company"].show();
    },
    onBtnCompanySearchDeleteClicked(companyObj) {
      var filteredAry = this.complainantCompany.filter(
        (o) => o.compId != companyObj.compId
      );

      this.complainantCompany = filteredAry;
    },
    onBtnCompanySearchSubmit() {
      const _this = this;
      this.$refs.modalCompanyComponent.$refs["modal-company"].hide();

      const index = this.complainantCompany?.findIndex(function(value) {
        return value.compId === _this.currentCompanyModal.compId;
      });

      if (index >= 0) {
        _this.$set(_this.complainantCompany, index, _this.currentCompanyModal);
      } else {
        _this.$set(
          _this.complainantCompany,
          _this.complainantCompany.length,
          _this.currentCompanyModal
        );
      }

      console.log("complainantCompany:", _this.complainantCompany);
    },
    setModalDataToDefault(id) {
      this.modalPersonalObj = {
        id: id + 1,
        identity: "",
        title: "",
        name: "",
        lastname: "",
        sex: "",
        dateofbirth: "",
        address: "",
        tumbon: "",
        ampher: "",
        province: "",
        zipcode: "",
        tel: "",
        mobile: "",
        email: "",
        line: "",
      };
    },
    setCompanyName(name) {
      this.company.name = name;
    },
    personalModalLocalSave(data, type) {
      console.log("personalModalLocalSave", data, type);
      var mapData = this.personals.find((item) => {
        return item.id === data.id;
      });
      if (mapData !== undefined) {
        //edit
        mapData = data;
      } else {
        //add
        var passByValue = JSON.parse(JSON.stringify(data));
        this.personals.push(passByValue);
        this.modalCurrentId += 1;
      }
    },
    attorneyModalLocalSave(data, type) {
      //console.log('attorneyModalLocalSave', data, type)
      var mapData = this.attorneys.find((item) => {
        return item.id === data.id;
      });
      if (mapData !== undefined) {
        //edit
        mapData = data;
      } else {
        //add
        var passByValue = JSON.parse(JSON.stringify(data));
        this.attorneys.push(passByValue);
        this.modalCurrentId += 1;
      }
    },
    personalDeleted(type, id) {
      console.log("personalDeleted", type, id);
      if (type === "personal") {
        this.personals = this.personals.filter((item) => {
          return item.userId !== id;
        });
      } else if (type === "attorney") {
        this.attorney = this.attorney.filter((item) => {
          return item.userId !== id;
        });
      }
    },
    personalModalClicked(type, id) {
      if (type === "personal") {
        this.modalMode = "personal";
        this.currentUserIdModal = id;
        this.$refs.modalDigitalIdComponent.$refs["modal-digital-id"].show();
      } else if (type === "attorney") {
        this.modalMode = "attorney";
        this.currentUserIdModal = id;
        this.$refs.modalDigitalIdComponent.$refs["modal-digital-id"].show();
      }
    },
    companyModalClicked(id) {
      this.currentCompIdModal = id;
      this.$refs.modalDigitalIdCompanyComponent.$refs[
        "modal-digital-id-company"
      ].show();
    },
    entrepreneurBtnAddClicked() {
      console.log("entrepreneurBtnAddClicked");
      const ids = this.entrepreneurs.map((item) => item.id);
      console.log("ids", ids);
      const id = Math.max(ids) + 1;
      this.entrepreneurs.push({
        id,
        name: "",
        detail: "",
        complaintDetail: "",
      });
    },
    tab1check() {
      console.log("this.company", this.company.complaintDetail);
      console.log("this.company", this.complaintDetailGCC);
      // return true;
      if (this.personals.length > 0) return true;
      else return false;
    },
    tab2check() {
      //return true;

      this.getAIMaster();
      this.checkCompanyMOUByCompany(this.complainantCompany);
      if (
        this.complainantCompany.length > 0 &&
        this.company.complaintDetail != ""
      )
        return true;

      return false;
    },
    tab3check() {
      console.log("tab3check");
      //return true;

      //console.log("1:", this.complaintDetail)
      //console.log("2:", this.complaintDetailMultiSelect)
      var check = true;

      this.complaintDetail.forEach((o) => {
        if (!o.tmMasterList) {
          //กรณี ประเภทร้องทุกข์ และ สาเหตุที่ต้องร้องทุกข์ ยังไม่ขึ้นบนหน้า front จะถือว่าไปต่อไม่ได้
          check = false;
        } else {
          //กรณีขึ้นครบแล้วต้องมีอย่างน้อย 1 check
          var checkList = o.tmMasterList.filter((o2) => {
            return o2.checked;
          });

          if (checkList.length == 0) {
            check = false;
          }
        }
      });

      // console.log("@tab3 check", check);
      // console.log(
      //   "@tab3 this.complaintDetailMultiSelect",
      //   this.complaintDetailMultiSelect
      // );
      if (check) {
        //multiselected ต้องมีอย่างน้อย 1 check
        this.complaintDetailMultiSelect.forEach((o) => {
          // console.log("@tab3 o", o);
          if (!o.tmMasterListSelected || o.tmMasterListSelected.length == 0) {
            // console.log(
            //   "@tab3 if o.tmMasterListSelected",
            //   o.tmMasterListSelected
            // );
            check = false;
          } else {
            // console.log(
            //   "@tab3 else o.tmMasterListSelected",
            //   o.tmMasterListSelected
            // );
            o.tmMasterListSelected.forEach((oo) => {
              // console.log("@tab3 else oo", oo);

              console.log("@tab3 else oo.masterId type", oo.masterId);
              console.log("@tab3 else oo.masterId type", typeof oo.masterId);

              // check amount value
              if (oo.masterId === 498 || oo.masterId === 499) {
                // console.log("@tab3 498||499 oo", oo.amount);
                if (
                  oo.amount === null ||
                  oo.amount === undefined ||
                  oo.amount === ""
                ) {
                  console.log("@tab3 if oo.amount");
                  check = false;
                } else {
                  if (oo.amount.includes("-")) {
                    console.log("@tab3 else oo.amount");
                    check = false;
                  }
                }
              }
            });
          }
        });
      }

      if (check) {
        if (this.needFastTrack) {
          if (this.selectedCompanyMou == null) {
            check = false;
          }

          if (!this.selectedCompanyMou.purchaseNo) {
            check = false;
          }
        }
      }

      if (!check) {
        this.$swal({
          title: "กรุณากรอกข้อมูลให้สมบูรณ์ !!",
          icon: "warning",
          showCancelButton: false,
          confirmButtonText: "ปิด",
          cancelButtonText: "ยกเลิก",
          customClass: {
            confirmButton: "btn btn-warning",
            cancelButton: "btn btn-outline-warning ml-1",
          },
          buttonsStyling: false,
        }).then((result) => {
          console.log("@tab swal ข้อมูลไม่สมบูรณ์ !!");
        });
      }

      return check;
      if (this.personals.length > 0) return true;
      else return false;
    },
    getCurrentDate() {
      const dateNow = new Date();
      return dateNow.toLocaleDateString("en-US");
    },
    formSubmitted() {
      var self = this;

      this.showLoading = true;

      try {
        this.$data.suggestions = null;
        this.$data.ComponentName = this.ComponentName; //set prop to data
        if (this.ComponentName === "ProvincialComplaint") {
          if (
            appsettings.complaintRoleId.province.toLowerCase() ===
            userData.selectedRole().toLowerCase()
          ) {
            this.$data.provinceCode = userData.province();
          }

          if (this.dateComplaint != "" && this.dateComplaint != null) {
            this.$data.dateComplaint = this.dateComplaint;
          } else {
            this.$data.dateComplaint = null;
          }
        }

        console.log("x:", this.$data);
        ComplaintAPI.ReceivingComplaint(this.$data)
          .then(function(response) {
            // handle success
            console.log("then", response);
            self.$toast({
              component: ToastificationContent,
              props: {
                title: "Form Submitted",
                icon: "EditIcon",
                variant: "success",
              },
            });
            //self.$router.push({ name: 'servicecentercomplaintcompleted' })
            if (self.ComponentName === "ProvincialComplaint") {
              self.$router.push({
                name: "servicecentercomplaintConfirm",
                query: {
                  parentComponent: self.ComponentName,
                  complaintGuid: response.data.data,
                  //isGroupGuid: true,
                },
              });
            } else {
              self.$router.push({
                name: "servicecentercomplaintConfirm",
                query: {
                  parentComponent: self.parentComponent,
                  complaintGuid: response.data.data,
                  //isGroupGuid: true,
                },
              });
            }
          })
          .catch(function(error) {
            // handle error
            console.log("error", error);
          })
          .then(function() {
            // always executed
            self.showLoading = false;
            console.log("GET");
          });
      } catch (ex) {
        self.showLoading = false;
        console.log("ex", ex);
      }
    },
    onAttachFileUploaded(file) {
      this.attachFiles.push(file);
    },
    onAttachFileDelete(id) {
      const file = this.attachFiles.find(function(value) {
        return value.attachId === id;
      });

      var filteredAry = this.attachFiles.filter((o) => o.attachId != id);

      this.attachFiles = filteredAry;
    },
    checkboxChanged(obj) {
      //console.log('this.selectedChannel', this.selectedChannel)
      if (obj.checked) {
        this.masterIdList.push(obj.masterId);
      } else {
        //uncheck
        this.masterIdList = this.masterIdList.filter((o) => {
          return o != obj.masterId;
        });

        //remove check ที่ masterTypeIdถัดๆไปทั้งหมด เมื่อมีการ uncheck ข้อมูล

        var notInside = [];
        //get remove list
        this.complaintDetail.forEach((o) => {
          if (obj.masterTypeId < o.masterTypeId) {
            o.tmMasterList.forEach((o2) => {
              notInside.push(o2.masterId);
            });
          }
        });

        console.log("notInside:", notInside);
        this.masterIdList = this.masterIdList.filter((o) => {
          return !notInside.includes(o);
        });
        //end check
      }

      console.log("masterIdList:", this.masterIdList);

      var self = this;

      ComplaintAPI.GetMasterTypeAll(this.masterIdList)
        .then(function(response) {
          console.log("response:", response);
          var dataList = response.data.data; //list รายการทั้งหมด
          //self.$refs.Step3Ref.refreshPage()

          //แสดงรายการ checkbox
          self.complaintDetail.forEach((o) => {
            o.tmMasterList = dataList.filter((o2) => {
              return o2.masterTypeId == o.masterTypeId;
            });
          });

          //ใส่ค่า check true
          self.complaintDetail.forEach((o) => {
            o.tmMasterList.forEach((o2) => {
              if (self.masterIdList.includes(o2.masterId)) {
                o2.checked = true;
              }
            });
          });
          self.$refs.Step3Ref.refreshPage();
        })
        .catch(function(error) {
          console.log("error", error);
        })
        .then(function() {});
      console.log("checkboxChangeRoot: ", obj);
    },
    onModalDigitalIdSuccess(id) {
      let _this = this;
      console.log("this", this.personals, this.attorneys);
      // need to get user id to update to view
      const currentUserId = id;
      this.currentUserIdModal = "";

      userStore
        .getById(currentUserId)
        .then(function(response) {
          // handle success
          console.log("userStore.getById", response);
          if (response.data.data !== null) {
            const person = response.data.data;

            const perIndex = _this.personals?.findIndex(function(value) {
              return value.userId === currentUserId;
            });

            const atIndex = _this.attorneys?.find(function(value) {
              return value.userId === currentUserId;
            });

            console.log("perIndex", perIndex, "atIndex", atIndex);

            if (perIndex >= 0 && perIndex != undefined) {
              _this.$set(_this.personals, perIndex, person);
            } else if (atIndex >= 0 && atIndex != undefined) {
              _this.$set(_this.attorneys, atIndex, person);
            } else {
              console.log(
                "personal",
                _this.personals,
                "attorneys",
                _this.attorneys
              );
              if (_this.modalMode === "personal") {
                //if (_this.personals === undefined) _this.personals = []
                _this.$set(_this.personals, _this.personals.length, person);
                //_this.personals.push(person)
              } else {
                //if (_this.attorneys === undefined) _this.attorneys = []
                _this.$set(_this.attorneys, _this.attorneys.length, person);
              }
              //console.log('personals', _this.personals, 'attorneys', _this.attorneys)
            }
          }

          //_this.$forceUpdate();
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        })
        .then(function() {
          // always executed
          _this.$refs.modalDigitalIdComponent.$refs["modal-digital-id"].hide();
        });
    },
    onModalDigitalIdCompanySuccess(id) {
      let _this = this;
      console.log("this", this.complainantCompany);
      console.log("onModalDigitalIdCompanySuccess", id);
      // need to get comp id to update to view
      const currentCompId = id;
      this.currentCompIdModal = "";

      companyStore
        .getById(currentCompId)
        .then((response) => {
          const company = {
            compId: response.data.data.compId,
            companyDetail: response.data.data.juristicNameTh,
            address: {},
          };

          if (
            response.data.data.juristicBranchTh !== null &&
            response.data.data.juristicBranchTh !== undefined
          ) {
            company.companyDetail = company.companyDetail.juristicBranchTh;
          }

          console.log("company", company);

          companyStore
            .getAddressDetail(company.compId)
            .then((response2) => {
              company.address = response2.data.data;

              const compIndex = _this.complainantCompany?.findIndex(function(
                value
              ) {
                return value.compId === currentCompId;
              });

              if (compIndex >= 0 && compIndex != undefined) {
                _this.$set(_this.complainantCompany, compIndex, company);
              } else {
                _this.$set(
                  _this.complainantCompany,
                  _this.complainantCompany.length,
                  company
                );
              }
            })
            .catch((error) => {
              console.log("error", error);
            });
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        })
        .then(function() {
          // always executed
          _this.$refs.modalDigitalIdCompanyComponent.$refs[
            "modal-digital-id-company"
          ].hide();
        });
    },
    updateSelectedChannel(value) {
      console.log("value", value);
      this.selectedChannel = value;
    },
    updateSelectedProvince(value) {
      console.log("province", value);
      this.provinceCode = value;
    },
    updateSelectedDateComplaint(value) {
      console.log("dateComplaint", value);
      this.dateComplaint = value;
    },
    onIsAttorneyComplaintChange(value) {
      this.isAttorneyCompliant = value;
      // if === true mean personals can have 1 person
      if (value === true) {
        if (this.personals.length > 1) {
          this.personals = this.personals.slice(0, 1);
        }
      } else {
        // if === false need to get rid of attorneys
        this.attorneys = [];
      }
    },
    getAIMaster() {
      //console.log('this.selectedChannel', this.selectedChannel)
      const _this = this;

      const params = {
        companyName: _this.company.name,
        complaintDetail: _this.company.complaintDetail,
      };

      ComplaintAPI.getAIMaster(params)
        .then((response) => {
          console.log("response", response);

          _this.masterIdList = [];
          _this.masterIdList.push(...response.data.data);

          ComplaintAPI.GetMasterTypeAll(_this.masterIdList)
            .then(function(response2) {
              console.log("response:", response2);
              var dataList = response2.data.data; //list รายการทั้งหมด
              //self.$refs.Step3Ref.refreshPage()

              //แสดงรายการ checkbox
              _this.complaintDetail.forEach((o) => {
                o.tmMasterList = dataList.filter((o2) => {
                  return o2.masterTypeId == o.masterTypeId;
                });
              });

              //ใส่ค่า check true
              _this.complaintDetail.forEach((o) => {
                o.tmMasterList.forEach((o2) => {
                  if (_this.masterIdList.includes(o2.masterId)) {
                    o2.checked = true;
                  }
                });
              });
              _this.$refs.Step3Ref.refreshPage();
            })
            .catch(function(error) {
              console.log("error", error);
            })
            .then(function() {});
          //console.log("checkboxChangeRoot: ", obj);
        })
        .catch((err) => {
          console.log("err", err);
        });
    },
    async checkCompanyMOUByCompany(complainantCompany) {
      if (!complainantCompany || complainantCompany.length === 0) return;
      console.log("@complainantCompany1", complainantCompany);

      const companyIds = complainantCompany
        .map((c) => c.compId)
        .filter(Boolean);

      if (companyIds.length === 0) return;

      await CompanyApi.getCompanyMOU(companyIds).then((response) => {
        console.log("@companyMOU", response.data);
        const mouList = response.data.data || [];
        console.log("@mouList", mouList);
        console.log("@complainantCompany2", complainantCompany);
        this.mouCompanies = complainantCompany.filter((c) =>
          mouList.some(
            (m) =>
              m.isMou &&
              String(m.companyId).toLowerCase() ==
                String(c.compId).toLowerCase()
          )
        );
        console.log("@mouCompanies", this.mouCompanies);
      });
    },
    onUpdateSelectedCompanyMou(selectedCompanyMou) {
      this.selectedCompanyMou = selectedCompanyMou;
      console.log(
        "@step.vue onUpdateSelectedCompanyMou",
        this.selectedCompanyMou
      );
    },
    onNeedFastTrackChange(needFastTrack) {
      this.needFastTrack = needFastTrack;
      console.log("@step.vue onNeedFastTrackChange", this.needFastTrack);
    },
  },
};
</script>

<style></style>
